import firebase from '../config/firebase';

export const TIMELINE = 'timeline';

export const TIMELINE_ACTION_TYPES = {
  CREATE_TIMELINE_EVENT: `${TIMELINE}/CREATE_TIMELINE_EVENT`,
  RECEIVE_TIMELINE_EVENT: `${TIMELINE}/RECEIVE_TIMELINE_EVENT`,
  FETCH_TIMELINE_EVENTS: `${TIMELINE}/FETCH_TIMELINE_EVENTS`,
  FETCH_DEFAULT_TIMELINE_EVENTS: `${TIMELINE}/FETCH_DEFAULT_TIMELINE_EVENTS`,
  RECEIVE_TIMELINE_EVENTS: `${TIMELINE}/RECEIVE_TIMELINE_EVENTS`,
  RECEIVE_DEFAULT_TIMELINE_EVENTS: `${TIMELINE}/RECEIVE_DEFAULT_TIMELINE_EVENTS`,
  RECEIVE_ACTIVE_EVENT: `${TIMELINE}/RECEIVE_ACTIVE_EVENT`,
  UPDATE_TIMELINE_EVENT: `${TIMELINE}/UPDATE_TIMELINE_EVENT`,
  DELETE_TIMELINE_EVENT: `${TIMELINE}/DELETE_TIMELINE_EVENT`,
  RECEIVE_DELETED_EVENT: `${TIMELINE}/RECEIVE_DELETED_EVENT`,
  RECEIVE_UPDATED_EVENT: `${TIMELINE}/RECEIVE_UPDATED_EVENT`
};

const functionURL = firebase.options_.functionURL

export const SEND_SCHEDULE_CHANGE_URL = functionURL + '/sendScheduleChangeNotification';



// WEBPACK FOOTER //
// ./src/redux/timeline/constants.js